import { render } from "./CustomerService.vue?vue&type=template&id=ef50c704&scoped=true"
import script from "./CustomerService.vue?vue&type=script&lang=js"
export * from "./CustomerService.vue?vue&type=script&lang=js"

import "./CustomerService.vue?vue&type=style&index=0&id=ef50c704&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-ef50c704"]])

export default __exports__